<template>
	<div
		class="search-dropdown-content invisible-scroll"
		:class="{
			'minheight-auto':
				!isSearching &&
				headerSearchQuery != '' &&
				headerSearchSuggestion.length == 0,
		}"
	>
		<template v-if="isSearching && headerSearchQuery != ''">
			<div class="px-4 py-2">
				<b-skeleton
					v-for="i in 8"
					:key="i"
					class="my-3"
					height="20px"
				></b-skeleton>
			</div>
		</template>
		<template
			v-else-if="headerSearchQuery != '' && headerSearchSuggestion.length > 0"
		>
			<div
				class="pointer"
				v-for="(value, index) in headerSearchSuggestion"
				:key="index + 'search'"
				@click="handleSearchClick(value)"
			>
				<article class="d-flex gap-3 align-items-center px-4 py-3">
					<img
						class="ml-2"
						src="../../assets/guestHeader/searchHead.svg"
						alt=""
					/>
					<span class="fam-inter fw-500 fs-16">
						{{
							selectedTab == "assessment" || selectedTab == "assessments"
								? value.name
								: value.title
						}}</span
					>
				</article>
			</div>
		</template>
		<template
			v-else-if="
				!isSearching &&
				headerSearchQuery != '' &&
				headerSearchSuggestion.length == 0
			"
		>
			<div
				class="d-flex align-items-center gap-3 justify-content-center py-3 fam-inter fw-500 fs-18 color-nodata flex-column"
			>
				<img src="../../assets/guestHeader/nodata.svg" alt="" />
				No Data Found
			</div>
		</template>
		<template v-else>
			<!-- Recent Search -->
			<div
				class="search-section mobmb-5px"
				:class="{ expanded: isRecentExpanded }"
				v-if="recentSearches && recentSearches.length > 0"
			>
				<div class="section-header px-1">
					<h3 class="section-title">Recent Search</h3>
					<button
						v-if="recentSearches && recentSearches.length > 0"
						class="clear-btn"
						@click="clearRecentSearches"
					>
						Clear
					</button>
				</div>
				<div class="mob-hor-scroll">
					<div
						class="tags-wrapper"
						:class="{
							'is-expanded': isRecentExpanded,
							'is-measuring': isMeasuringRecent,
							loading: isTagsLoading,
						}"
					>
						<div class="search-tags" ref="recentTagsContainer">
							<template v-if="isTagsLoading">
								<div class="tags-row" v-if="!isLaptop">
									<b-skeleton
										v-for="i in 5"
										:key="i + 'recent-shimmer-1'"
										width="100px"
										height="30px"
										style="border-radius: 20px"
									></b-skeleton>
								</div>
								<div class="tags-row" v-if="!isLaptop">
									<b-skeleton
										v-for="i in 5"
										:key="i + 'recent-shimmer-2'"
										width="100px"
										height="30px"
										style="border-radius: 20px"
									></b-skeleton>
								</div>
								<template v-if="isLaptop">
									<b-skeleton
										v-for="i in 5"
										:key="i + 'recent-shimmer-desktop'"
										width="130px"
										height="30px"
										style="border-radius: 20px"
									></b-skeleton>
								</template>
							</template>
							<template v-else>
								<!-- Desktop Layout -->
								<template v-if="isLaptop">
									<div
										class="search-tag"
										v-for="(tag, index) in visibleRecentSearches"
										:key="`recent-dt-${index}`"
										ref="recentTag"
										@click="handleSearchClick(tag)"
									>
										<img
											src="../../assets/guestHeader/black-search.svg"
											alt="Recent Search Icon"
											class="tag-icon"
										/>
										<span class="tag-text">
											{{
												typeof tag === "string"
													? tag
													: tag.searchQuery || tag.tag || tag.query || tag.name
											}}
										</span>
									</div>
									<div
										class="toggle-expand"
										:style="hasAccess() && 'color: #4a7eff !important'"
										ref="recentToggle"
										v-if="
											showRecentToggle && !isTagsLoading && !isMeasuringRecent
										"
										@click.stop="isRecentExpanded = !isRecentExpanded"
									>
										{{ isRecentExpanded ? "Show Less" : "Show More" }}
									</div>
								</template>

								<!-- Mobile Layout -->
								<template v-else>
									<div class="tags-row">
										<div
											class="search-tag"
											v-for="(tag, index) in recentSearchRows.row1"
											:key="`recent-r1-${index}`"
											ref="recentTag"
											@click="handleSearchClick(tag)"
										>
											<img
												src="../../assets/guestHeader/black-search.svg"
												alt="Recent Search Icon"
												class="tag-icon"
											/>
											{{
												typeof tag === "string"
													? tag
													: tag.searchQuery || tag.tag || tag.query || tag.name
											}}
										</div>
									</div>
									<div class="tags-row" v-if="recentSearchRows.row2.length > 0">
										<div
											class="search-tag"
											v-for="(tag, index) in recentSearchRows.row2"
											:key="`recent-r2-${index}`"
											ref="recentTag"
											@click="handleSearchClick(tag)"
										>
											<img
												src="../../assets/guestHeader/black-search.svg"
												alt="Recent Search Icon"
												class="tag-icon"
											/>
											{{
												typeof tag === "string"
													? tag
													: tag.searchQuery || tag.tag || tag.query || tag.name
											}}
										</div>
									</div>
								</template>
							</template>
						</div>
					</div>
				</div>
			</div>

			<!-- Explore -->
			<div class="search-section">
				<div class="d-flex gap-2 align-items-center">
					<h3 class="section-title">Explore</h3>
					<div id="hideinlaptop" class="hor-line"></div>
				</div>
				<div class="explore-grid">
					<div class="scroll">
						<div
							class="explore-item"
							v-for="item in exploreItems"
							:key="item.name"
							@click="
								hasAccess()
									? handleExploreClick(item)
									: handleLoggedOutExploreClick(item)
							"
						>
							<div class="explore-icon">
								<img :src="item.icon" :alt="item.name" />
							</div>
							<span class="explore-label">{{ item.name }}</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Trending -->
			<div v-if="trendingTags && trendingTags.length" class="search-section" :class="{ expanded: isTrendingExpanded }">
				<div class="d-flex gap-2 align-items-center">
					<h3 class="section-title">Trending on Hire3x</h3>
					<div id="hideinlaptop" class="hor-line"></div>
				</div>
				<div class="mob-hor-scroll mt-4">
					<div
						class="tags-wrapper"
						:class="{
							'is-expanded': isTrendingExpanded,
							'is-measuring': isMeasuringTrending,
							loading: isTagsLoading,
						}"
					>
						<div class="trending-tags" ref="trendingTagsContainer">
							<template v-if="isTagsLoading">
								<div class="tags-row" v-if="!isLaptop">
									<b-skeleton
										v-for="i in 5"
										:key="i + 'trend-shimmer-1'"
										width="100px"
										height="30px"
										style="border-radius: 20px"
									></b-skeleton>
								</div>
								<div class="tags-row" v-if="!isLaptop">
									<b-skeleton
										v-for="i in 5"
										:key="i + 'trend-shimmer-2'"
										width="100px"
										height="30px"
										style="border-radius: 20px"
									></b-skeleton>
								</div>
								<template v-if="isLaptop">
									<b-skeleton
										v-for="i in 5"
										:key="i + 'shimmer'"
										width="130px"
										height="30px"
										style="border-radius: 20px"
									></b-skeleton>
								</template>
							</template>
							<template v-else>
								<!-- Desktop Layout -->
								<template v-if="isLaptop">
									<span
										class="trending-tag"
										v-for="(tag, index) in visibleTrendingTags"
										:key="`trending-dt-${index}`"
										ref="trendingTag"
										@click="
											hasAccess()
												? handleTrendingClick(tag)
												: handleLoggeOutTrendingClick(tag)
										"
									>
										{{
											typeof tag === "string"
												? tag
												: selectedTab == "assessment" ||
												  selectedTab == "assessments"
												? tag.testName || tag.name || tag.title || ""
												: tag.title ||
												  tag.courseName ||
												  tag.name ||
												  tag.tagName ||
												  tag.searchTerm ||
												  ""
										}}
									</span>
									<div
										class="toggle-expand"
										ref="trendingToggle"
										:style="hasAccess() && 'color: #4a7eff !important'"
										v-if="
											showTrendingToggle &&
											!isTagsLoading &&
											!isMeasuringTrending
										"
										@click.stop="isTrendingExpanded = !isTrendingExpanded"
									>
										{{ isTrendingExpanded ? "Show Less" : "Show More" }}
									</div>
								</template>

								<!-- Mobile Layout -->
								<template v-else>
									<div class="tags-row">
										<span
											class="trending-tag"
											v-for="(tag, index) in trendingSearchRows.row1"
											:key="`trending-r1-${index}`"
											ref="trendingTag"
											@click="
												hasAccess()
													? handleTrendingClick(tag)
													: handleLoggeOutTrendingClick(tag)
											"
										>
											{{
												typeof tag === "string"
													? tag
													: selectedTab == "assessment" ||
													  selectedTab == "assessments"
													? tag.testName || tag.name || tag.title || ""
													: tag.title ||
													  tag.courseName ||
													  tag.name ||
													  tag.tagName ||
													  tag.searchTerm ||
													  ""
											}}
										</span>
									</div>
									<div
										class="tags-row"
										v-if="trendingSearchRows.row2.length > 0"
									>
										<span
											class="trending-tag"
											v-for="(tag, index) in trendingSearchRows.row2"
											:key="`trending-r2-${index}`"
											ref="trendingTag"
											@click="
												hasAccess()
													? handleTrendingClick(tag)
													: handleLoggeOutTrendingClick(tag)
											"
										>
											{{
												typeof tag === "string"
													? tag
													: selectedTab == "assessment" ||
													  selectedTab == "assessments"
													? tag.testName || tag.name || tag.title || ""
													: tag.title ||
													  tag.courseName ||
													  tag.name ||
													  tag.tagName ||
													  tag.searchTerm ||
													  ""
											}}
										</span>
									</div>
								</template>
							</template>
						</div>
					</div>
				</div>
			</div>
			<!-- Build Career Section -->
			<div class="build-section">
				<div class="build-heading">
					Don't Just Work. Build a Career <br id="hideinmobile" />You Love.
				</div>
				<div class="double-image">
					<img
						class="one"
						src="../../assets/guestHeader/blue-banner-4.svg"
						alt="Build a career background"
					/>
					<img
						class="two"
						src="../../assets/guestHeader/person-hire3x.svg"
						alt="Person pointing at Hire3x text"
					/>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { config } from "@/config";
import { hasAccess, openLoginModal } from "@/utils/tokenCheck";
import globalSearchMixin from "@/components/mixin/globalSearchMixin";

export default {
	name: "SearchDropdown",
	mixins: [globalSearchMixin],
	data() {
		return {
			isTagsLoading: true,
			exploreItems: [
				{
					name: "Resume",
					icon: require("../../assets/guestHeader/resumeweb.webp"),
				},
				{
					name: "Interviews",
					icon: require("../../assets/guestHeader/scaredweb.webp"),
				},
				{
					name: "Jobs",
					icon: require("../../assets/guestHeader/lookingweb.webp"),
				},
				{
					name: "Courses",
					icon: require("../../assets/guestHeader/booksweb.webp"),
				},
				{
					name: "Roadmap",
					icon: require("../../assets/guestHeader/Preview.webp"),
				},
				{
					name: "Fix Resume",
					icon: require("../../assets/guestHeader/shortlistweb.webp"),
				},
				{
					name: "Assessment",
					icon: require("../../assets/guestHeader/cupweb.webp"),
				},
				// {
				// 	name: "Mentor",
				// 	icon: require("../../assets/guestHeader/h-mentor.svg"),
				// },
			],
			trendingTags: [],
			isRecentExpanded: false,
			isTrendingExpanded: false,
			isMeasuringRecent: false,
			isMeasuringTrending: false,
			recentLimit: 2,
			trendingLimit: 2,
			isLaptop: true,
		};
	},
	props: {
		selectedTab: String,
		headerSearchSuggestion: Array,
		headerSearchQuery: String,
		isSearching: Boolean,
		isVisible: Boolean,
	},
	computed: {
		visibleRecentSearches() {
			if (!this.isLaptop) return this.recentSearches;
			if (this.isRecentExpanded || this.isMeasuringRecent) {
				return this.recentSearches;
			}
			return this.recentSearches.slice(0, this.recentLimit);
		},
		showRecentToggle() {
			if (!this.isLaptop) return false;
			return (
				this.recentSearches.length > this.recentLimit || this.isRecentExpanded
			);
		},
		visibleTrendingTags() {
			if (!this.isLaptop) return this.trendingTags;
			if (this.isTrendingExpanded || this.isMeasuringTrending) {
				return this.trendingTags;
			}
			return this.trendingTags.slice(0, this.trendingLimit);
		},
		showTrendingToggle() {
			if (!this.isLaptop) return false;
			return (
				this.trendingTags.length > this.trendingLimit || this.isTrendingExpanded
			);
		},
		recentSearchRows() {
			const len = this.recentSearches.length;
			if (this.isLaptop || len === 0) {
				return { row1: [], row2: [] };
			}
			if (len <= 3) {
				return { row1: this.recentSearches, row2: [] };
			}
			const half = Math.ceil(len / 2);
			return {
				row1: this.recentSearches.slice(0, half),
				row2: this.recentSearches.slice(half),
			};
		},
		trendingSearchRows() {
			const len = this.trendingTags.length;
			if (this.isLaptop || len === 0) {
				return { row1: [], row2: [] };
			}
			if (len <= 3) {
				return { row1: this.trendingTags, row2: [] };
			}
			const half = Math.ceil(len / 2);
			return {
				row1: this.trendingTags.slice(0, half),
				row2: this.trendingTags.slice(half),
			};
		},
	},
	watch: {
		selectedTab(value) {
			if (value) {
				this.loadSearchData();
				this.isRecentExpanded = false;
				this.isTrendingExpanded = false;
			}
		},
		isTagsLoading(value) {
			if (!value) {
				this.$nextTick(() => {
					this.updateLimits();
				});
			}
		},
		recentSearches() {
			this.updateLimits();
		},
		trendingTags() {
			this.updateLimits();
		},
		isVisible(newVal) {
			if (newVal) {
				setTimeout(() => {
					this.updateLimits();
				}, 150);
			}
		},
	},
	created() {
		this.loadSearchData();
	},
	mounted() {
		this.checkScreenSize();
		// Delay measurement to ensure smooth opening transition
		setTimeout(() => {
			this.updateLimits();
			window.addEventListener("resize", this.handleResize);
			this.resizeObserver = new ResizeObserver(() => {
				this.handleResize();
			});
			if (this.$refs.recentTagsContainer)
				this.resizeObserver.observe(this.$refs.recentTagsContainer);
			if (this.$refs.trendingTagsContainer)
				this.resizeObserver.observe(this.$refs.trendingTagsContainer);
		}, 150);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleResize);
		if (this.resizeObserver) this.resizeObserver.disconnect();
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		hasAccess() {
			return hasAccess();
		},
		async loadSearchData() {
			this.isTagsLoading = true;
			try {
				await Promise.all([
					this.getRecentSearches(this.selectedTab, 50),
					this.getTrendingTagsData(this.selectedTab),
				]);
			} finally {
				this.isTagsLoading = false;
			}
		},
		getOneRowLimit(tagRefName, totalItems) {
			const tagNodes = this.$refs[tagRefName];
			if (!tagNodes) return 0;

			const tags = Array.isArray(tagNodes) ? tagNodes : [tagNodes];
			if (!tags.length) return 0;

			const rowTops = [];
			let oneRowIndex = tags.length;

			const addRowTop = (top) => {
				if (top === undefined) return;
				const exists = rowTops.some((rowTop) => Math.abs(rowTop - top) < 15);
				if (!exists) {
					rowTops.push(top);
				}
			};

			for (let i = 0; i < tags.length; i++) {
				const top = tags[i].offsetTop;
				addRowTop(top);
				if (rowTops.length > 1) {
					oneRowIndex = i;
					break;
				}
			}

			// Reserve one slot for Show More button if there are more items beyond this limit
			if (totalItems > oneRowIndex && oneRowIndex > 0) {
				oneRowIndex = Math.max(1, oneRowIndex - 1);
			}

			return oneRowIndex;
		},
		handleResize() {
			this.checkScreenSize();
			this.updateLimits();
		},
		updateLimits() {
			if (!this.isRecentExpanded) {
				this.recentLimit = this.recentSearches.length;
				this.isMeasuringRecent = true;
			}
			if (!this.isTrendingExpanded) {
				this.trendingLimit = this.trendingTags.length;
				this.isMeasuringTrending = true;
			}

			this.$nextTick(() => {
				this.$nextTick(() => {
					if (!this.isRecentExpanded) {
						const recentOneRowLimit = this.getOneRowLimit(
							"recentTag",
							this.recentSearches.length
						);
						this.recentLimit =
							recentOneRowLimit > 0
								? recentOneRowLimit
								: Math.min(this.recentSearches.length, 6);
						if (this.recentSearches.length > this.recentLimit) {
							this.$nextTick(() => {
								this.ensureMaxOneRowWithToggle(
									"recentTag",
									"recentToggle",
									"recentLimit",
									this.recentSearches.length
								);
							});
						}
					}

					if (!this.isTrendingExpanded) {
						const trendingOneRowLimit = this.getOneRowLimit(
							"trendingTag",
							this.trendingTags.length
						);
						this.trendingLimit =
							trendingOneRowLimit > 0
								? trendingOneRowLimit
								: Math.min(this.trendingTags.length, 4);
						if (this.trendingTags.length > this.trendingLimit) {
							this.$nextTick(() => {
								this.ensureMaxOneRowWithToggle(
									"trendingTag",
									"trendingToggle",
									"trendingLimit",
									this.trendingTags.length
								);
							});
						}
					}

					this.isMeasuringRecent = false;
					this.isMeasuringTrending = false;
				});
			});
		},
		ensureMaxOneRowWithToggle(tagRefName, toggleRefName, limitKey, totalItems) {
			const toggleNode = this.$refs[toggleRefName];
			const tagNodes = this.$refs[tagRefName];
			if (!toggleNode || !tagNodes) return;

			const tags = Array.isArray(tagNodes) ? tagNodes : [tagNodes];
			if (!tags.length) return;

			const rowTops = [];
			const addRowTop = (top) => {
				if (top === undefined) return;
				const exists = rowTops.some((rowTop) => Math.abs(rowTop - top) < 15);
				if (!exists) {
					rowTops.push(top);
				}
			};

			tags.forEach((tag) => {
				if (tag && tag.offsetTop !== undefined) {
					addRowTop(tag.offsetTop);
				}
			});

			if (toggleNode.offsetTop !== undefined) {
				addRowTop(toggleNode.offsetTop);
			}

			if (rowTops.length > 1 && this[limitKey] > 1) {
				this[limitKey] = Math.max(1, this[limitKey] - 1);
				if (totalItems > this[limitKey]) {
					this.$nextTick(() => {
						this.ensureMaxOneRowWithToggle(
							tagRefName,
							toggleRefName,
							limitKey,
							totalItems
						);
					});
				}
			}
		},
		handleSearchClick(tag) {
			const query =
				typeof tag === "string"
					? tag
					: tag.searchQuery ||
					  tag.tag ||
					  tag.query ||
					  tag.name ||
					  tag.title ||
					  tag.courseName;

			if (query) {
				const type = this.selectedTab;
				this.$emit("close-modal");
				this.handleEnterSearch(query, type);
			}
		},
		goToCourseDetail(tag) {
			this.$emit("close-modal");
			const courseName = tag.title || tag.courseName || tag.name;
			const courseId =
				tag.courseID || tag.courseId || tag.referenceID || tag.id;
			if (!courseId) return;

			// Track search interaction before redirecting
			this.trackSearchInteraction(courseName, "courses");

			const encodedCourseName = encodeURIComponent(courseName || "");
			const link = `${this.config.trainingBase}/coursedetail/${courseId}?courseName=${encodedCourseName}`;
			window.open(link, "_self");
		},
		goToJobDetail(tag) {
			this.$emit("close-modal");
			const jobId = tag.jobID || tag.referenceID || tag.id;
			const jobTitle = tag.title || tag.name || tag.jobTitle;

			// Track interaction
			this.trackSearchInteraction(jobTitle, "job");

			if (jobId) {
				this.$router.push({
					path: "/jobinfo",
					query: { jobID: jobId, fromPage: this.$route.name },
				});
			} else {
				this.handleEnterSearch(jobTitle, "job");
			}
		},
		goToAssessmentDetail(tag) {
			this.$emit("close-modal");
			const testId = tag.testID || tag.testId || tag.referenceID || tag.id;
			const testName = tag.testName || tag.title || tag.name;

			// Track interaction
			this.trackSearchInteraction(testName, "assessment");

			if (testId) {
				const routePath = this.hasAccess()
					? "/assessment/toAssessmentWeb"
					: "/testdetails";
				this.$router.push({
					path: routePath,
					query: { testID: testId },
				});
			} else {
				this.handleEnterSearch(testName, "assessment");
			}
		},
		goToTrendingJobDetail(tag) {
			this.$emit("close-modal");
			const queryTerm = tag.title || tag.name || tag.jobTitle || "";
			const jobId = tag.jobID || tag.jobId || tag.referenceID || tag.id;

			if (!queryTerm) return;

			this.trackSearchInteraction(queryTerm, "job");
			const query = {
				screen: "job-details",
				searchQuery: queryTerm,
				tab: "hire",
			};

			if (jobId) {
				query.jobID = jobId;
			}

			this.$router.push({
				path: "/job/search",
				query: { ...query, fromPage: this.$route.name },
			});
		},
		handleExploreClick(item) {
			const isGuest = !this.hasAccess();
			if (isGuest) {
				this.handleLoggedOutExploreClick(item);
				return;
			}
			switch (item.name) {
				case "Resume":
					this.$emit("close-modal");
					this.$router.push({ name: "CandidateDashboard" });
					break;
				case "Interviews":
					this.$emit("close-modal");
					this.$router.push({ name: "InterviewKickstart" });
					break;
				case "Jobs":
					this.$emit("close-modal");
					this.$router.push({ name: "JobSearch" });
					break;
				case "Courses":
					this.$emit("close-modal");
					window.location.href = `${this.config.trainingBase}/marketplace`;
					break;
				case "Roadmap":
					this.$emit("close-modal");
					this.$router.push({ name: "InterviewKickstart" });
					break;
				case "Assessment":
					this.$emit("close-modal");
					this.$router.push({ name: "AssessmentMarketplace" });
					break;
				case "Fix Resume":
					this.$emit("close-modal");
					this.$emit("openResumeClinic");
					break;
			}
		},
		handleLoggedOutExploreClick(item) {
			switch (item.name) {
				case "Resume":
					this.$emit("close-modal");
					openLoginModal({
						redirectUrl: `${this.config.candidateBase}/dashboard/?from=candidate`,
					});
					break;
				case "Interviews":
					this.$emit("close-modal");
					window.location.href = `${this.config.websiteBase}#mockinterviews`;
					break;
				case "Jobs":
					this.$emit("close-modal");
					window.location.href = `${this.config.websiteBase}#jobs`;
					break;
				case "Courses":
					this.$emit("close-modal");
					window.location.href = `${this.config.websiteBase}#courses`;
					break;
				case "Roadmap":
					this.$emit("close-modal");
					window.location.href = `${this.config.websiteBase}#mockinterviews`;
					break;
				case "Assessment":
					this.$emit("close-modal");
					window.location.href = `${this.config.websiteBase}#assessments`;
					break;
				case "Fix Resume":
					this.$emit("close-modal");
					this.$emit("openResumeClinic");
					break;
			}
		},
		requestLoginModal() {
			this.$emit("open-login-modal", true);
		},
		handleLoggeOutTrendingClick(tag) {
			const type = this.selectedTab;
			if (type === "courses" || type === "course" || type === 3) {
				this.goToCourseDetail(tag);
			} else if (type === "job" || type === "jobs" || type === 1) {
				this.goToJobDetail(tag);
			} else if (
				type === "assessment" ||
				type === "assessments" ||
				type === 2
			) {
				this.goToAssessmentDetail(tag);
			} else {
				const queryTerm = tag.testName || tag.title || tag.name;
				this.handleEnterSearch(queryTerm, type);
			}
		},
		handleTrendingClick(tag) {
			const type = this.selectedTab;
			if (type === "courses" || type === "course" || type === 3) {
				this.goToCourseDetail(tag);
				return;
			}

			if (type === "job" || type === "jobs" || type === 1) {
				this.goToTrendingJobDetail(tag);
				return;
			}

			const queryTerm =
				type === "assessment" || type === "assessments" || type === 2
					? tag.testName || tag.name || tag.title || ""
					: tag.title || tag.courseName || tag.name || tag.tagName || "";

			this.handleEnterSearch(queryTerm, type);
		},
	},
};
</script>

<style lang="scss">
.search-dropdown-content {
	background: white;
	border-radius: 20px;
	width: 100%;
	margin-top: 8px;
	padding: 20px 0 0;
	opacity: 0;
	animation: slideDown 0.3s ease 0.1s forwards;
	position: absolute;
	top: 100%;
	left: 50%;
	max-height: 75vh;
	overflow-y: auto;
	transform: translateX(-50%);
	box-shadow: 8px 2px 19px 0px #0000001a, 33px 10px 35px 0px #00000017,
		75px 22px 47px 0px #0000000d, 133px 38px 56px 0px #00000003,
		208px 60px 61px 0px #00000000;
}

@keyframes slideDown {
	from {
		opacity: 0;
		transform: translate(-50%, 40px);
	}

	to {
		opacity: 1;
		transform: translate(-50%, 0);
	}
}

/* Search Dropdown Styles */
.search-section {
	margin-bottom: 13px;
	padding-inline: 20px;
}

.search-section:last-child {
	margin-bottom: 0;
}

.section-header {
	display: flex;
	gap: 30px;
	align-items: center;
	margin-bottom: 16px;
}

.section-title {
	font-size: 18px;
	font-weight: 600;
	color: #1a1a1a;
	margin: 0;
}

.clear-btn {
	background: none;
	border: none;
	color: #6b7280;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	padding: 0;
}

.clear-btn:hover {
	color: #4a7eff;
}

.tags-wrapper {
	position: relative;
	margin-top: 16px;
	overflow: hidden;
	transition: max-height 0.3s ease;

	&:not(.is-expanded):not(.is-measuring) {
		max-height: 55px;
	}

	&.loading:not(.is-expanded) {
		max-height: 55px;
		min-height: 55px;
	}

	&.is-expanded {
		max-height: none;
	}
}

.toggle-expand {
	display: inline-flex;
	align-items: center;
	color: #20639b;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	text-decoration: underline;
	transition: all 0.2s ease;
	white-space: nowrap;
	height: 32px;
	padding: 4px 12px;
	margin: 0 0 0 4px;
	flex-shrink: 0;
}

.toggle-expand:hover {
	opacity: 0.8;
}

.search-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	align-items: center;
	padding-bottom: 12px;
}

.search-section.expanded .search-tags {
	max-height: none;
}

.search-tag {
	display: flex;
	align-items: center;
	gap: 8px;
	background: #f9f9f9;
	border-radius: 20px;
	padding: 4px 16px;
	font-family: "Inter", sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #646464;
	cursor: pointer;
	transition: all 0.2s ease;
	min-width: 0;
	overflow: hidden;
	flex: 0 1 auto;
	max-width: 100%;
}

.search-tag:hover {
	background: #e8f0ff;
}

.tag-icon {
	width: 14px;
	height: 14px;
}

.explore-grid {
	display: flex;
	flex-wrap: wrap;
	gap: 24px;
	margin-top: 16px;
}
.explore-grid .scroll {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	gap: 24px;
	flex-shrink: 0;
}

.explore-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	cursor: pointer;
	transition: transform 0.2s ease;
}

.explore-item:hover {
	transform: translateY(-2px);
}

.explore-item:hover .explore-icon {
	background: #e3f2fd;
}

.explore-label {
	font-size: 14px;
	font-weight: 400;
	color: #2e425d;
	font-family: "Inter", sans-serif;
	margin-top: 6px;
}

.trending-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	align-items: center;
	padding-bottom: 12px;
}

.search-section.expanded .trending-tags {
	max-height: none;
}

.trending-tag {
	display: inline-flex;
	align-items: center;
	background: #f0f7ff;
	border: 1px solid #c4dcf6;
	color: #20639b;
	font-family: "Inter", sans-serif;
	border-radius: 20px;
	padding: 4px 16px;
	font-size: 16px;
	font-weight: 400;
	cursor: pointer;
	transition: all 0.2s ease;
	flex: 0 1 auto;
	justify-content: center;
	text-align: center;
}

.trending-tag:hover {
	background: #ffffff;
	border: 1px solid #4a7eff;
	color: #4a7eff;
}

.build-section {
	background: url("~@/assets/guestHeader/waves.png"),
		linear-gradient(
			67.34deg,
			#073787 0.46%,
			#073583 30.97%,
			#083078 58.08%,
			#0a2765 85.2%,
			#0c1c4b 111.18%,
			#0d1b49 113.44%
		);
	background-blend-mode: soft-light;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 150px;
	min-height: 180px;
}

.build-section .double-image {
	position: relative;
	width: 300px;
	display: flex;
	justify-content: center;
}

.build-section .double-image .one {
	position: absolute;
	top: 0;
	left: 0;
	animation: float 6s ease-in-out infinite;
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0px);
	}
	50% {
		transform: translateY(-12px);
	}
}

.build-heading {
	font-family: "Manrope", sans-serif;
	font-size: 60px;
	font-weight: 800;
	line-height: 80px;
	text-align: left;
	color: #ffffff;
}

.search-dropdown-content {
	.build-heading {
		font-size: 34px;
		line-height: 40px;
	}
	.build-section .double-image {
		width: 200px;
	}
	.build-section {
		padding: 0 90px;
	}
	.double-image .one {
		top: 15px;
		left: 0px;
		height: 111px;
	}
	.double-image .two {
		height: 172px;
	}
}

/* Mobile Responsive */
@media (max-width: 1028px) {
	.mobmb-5px {
		margin-bottom: 5px;
	}
	.mobmb-0 {
		margin-bottom: 0 !important;
	}
	.search-tag {
		max-width: none;
		white-space: nowrap;
		flex-shrink: 0;
		justify-content: flex-start;
		width: max-content;
	}
	.tags-wrapper {
		margin-top: 0;
	}
	.search-dropdown-content {
		width: 100%;
		padding: 0px;
		margin-top: -1px;
		padding-top: 10px;
		box-shadow: none;
		animation: slideDown 0s ease 0s forwards;
		transform: unset;
	}

	.explore-grid {
		gap: 16px;
		// overflow-x: auto;
		width: 100%;
	}
	.explore-grid .scroll {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		gap: 16px;
		flex-shrink: 0;
	}
	.explore-grid::-webkit-scrollbar {
		display: none;
	}
	.search-tags {
		gap: 8px;
	}

	.trending-tags {
		gap: 8px;
		overflow: auto;
	}

	.search-tag,
	.trending-tag {
		font-size: 12px;
		padding: 6px 12px;
	}

	.build-heading {
		font-size: 22px;
		line-height: 31px;
	}

	.build-section .double-image .one {
		height: 100px;
	}

	.build-section .double-image .two {
		height: 160px;
	}

	.build-section {
		padding: 0 30px;
	}

	.section-title {
		font-size: 16px;
		color: #344054;
	}

	.section-header {
		justify-content: space-between;
	}

	.search-section {
		padding-inline: 5px;
		padding: 0 15px;
	}

	.search-section .hor-line {
		background-color: #d6d6d6;
		flex: 1;
		height: 1px;
	}

	.search-dropdown-content {
		.build-heading {
			font-size: 20px;
			line-height: 27px;
		}
		.build-section {
			padding: 0 20px;
			min-height: 100px;
		}
		.build-section .double-image .two {
			height: 90px;
		}
		.build-section .double-image .one {
			height: 54px;
		}
		.build-section .double-image {
			width: 176px;
		}
		.mob-hor-scroll {
			width: 100%;
			overflow-x: auto;
			-webkit-overflow-scrolling: touch;
		}
		.mob-hor-scroll::-webkit-scrollbar {
			display: none;
		}
		.mob-hor-scroll .tags-wrapper {
			width: max-content;
			overflow: visible;
			max-height: none !important;
		}
		.mob-hor-scroll .search-tags,
		.mob-hor-scroll .trending-tags {
			display: flex;
			flex-direction: column;
			gap: 8px;
			width: max-content;
			max-height: none;
			overflow: visible;
			padding-bottom: 8px;
			align-items: flex-start;
		}
		.tags-row {
			display: flex;
			flex-direction: row;
			gap: 8px;
			width: max-content;
		}
	}
}
.tag-text {
	flex: 1; /* take remaining space */
	min-width: 0; /* VERY IMPORTANT for flex */
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.color-nodata {
	color: #909090;
}
.minheight-auto {
	min-height: auto !important;
}
</style>
